import styled from "styled-components";
import { fonts, colors } from "../../../styles/variables";
import saveIcon from "../../../assets/images/temp/bookmark-empty.svg";
import bookmarkedIcon from "../../../assets/images/temp/bookmark-fill.svg";

export const BottleInfoTrayCard = styled.div`
  &:not(:last-child) {
    margin-bottom: 20px;
  }
  border: 1px solid ${colors.black};
  display: flex;
  flex-flow: row nowrap;
  height: 100px;
  cursor: pointer;
`;

export const BottleInfoTrayCardImageHolder = styled.div`
  width: 100px;
  display: flex;
`;

export const BottleInfoTrayCardBody = styled.div`
  padding: 10px 0;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  padding: 0 20px;
`;

export const ListTitleAndQuantityContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const BottleInfoTrayCardTitle = styled.label`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 22px;
  margin: 0;
  display: inline-block;
  width: 100%;
  cursor: pointer;
  > span {
    font-size: 16px;
  }
`;

export const BottleInfoTrayCardQta = styled.span`
  display: inline-block;
  font-size: 20px;
  font-size: 12px;
  width: 100%;
`;

export const BottleInfoTrayCardSave = styled.div`
  display: flex;
  width: 18px;
  height: 18px;
  background: ${(props) =>
    props.isBookmarked
      ? `url("${bookmarkedIcon}") no-repeat 50% 50% / contain`
      : `url("${saveIcon}") no-repeat 50% 50% / contain`};
`;

export const NotLoggedInButtonHolder = styled.div`
  width: 100%;
  text-align: center;
`;
